import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import DOMPurify from 'dompurify'
import { truncate } from 'lodash'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateBackendDateTimeToRelativeTime } from 'modules/core/lib/dates'

import type { Message } from 'modules/finance/hooks/useMessages'

interface Props {
  message: Message
}

const MessageItem = ({ message }: Props) => {
  const { id, isRead, from, createdAt, subject, content } = message

  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const params = useParams()
  const messageId = Number(params.messageId)

  const selected = messageId === id

  if (!id) return null

  const seeMessageUrl = navigation.finance.invoices.inbox.messageId.fullPath({
    messageId: id,
  })

  const text = DOMPurify.sanitize(content || '', {
    USE_PROFILES: { html: false },
  })

  const truncatedName = truncate(text, { length: 115 })

  return (
    <Box
      component="li"
      onClick={() => navigate(seeMessageUrl)}
      cursor="pointer"
      background={selected ? 'grey200' : 'grey000White'}
      paddingY="s12"
      paddingX="s16"
      gap="s4"
      border={{
        bottom: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Box flexDirection="row" gap="s16" justifyContent="spaceBetween" alignItems="center">
        <Box flexDirection="row" gap="s8" alignItems="center" flexGrow>
          {!isRead && <Icon.Tiny icon="circle" color="champagne1000" />}
          <Text.Normal weight="medium" color="grey1000">
            {from}
          </Text.Normal>
        </Box>
        <Text.Normal size="200">{dateBackendDateTimeToRelativeTime(createdAt)}</Text.Normal>
      </Box>
      <Text.Normal size="200" color="grey1000">
        {subject}
      </Text.Normal>
      <Box paddingTop="s4" maxHeight="s48" overflowY="hidden">
        <Text.Normal size="200" color="grey800">
          {truncatedName}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default MessageItem
